export enum SeatNeed {
  //Null = "",
  None = "None",
  Chair_0 = "Chair_0",
  Chair_1 = "Chair_1",
  Chair_2 = "Chair_2",
  Chair_3 = "Chair_3",
  //Stroller = "Trolley",
  Carrier = "Carrier",
  //Wheelchair = "Wheelchair",
  Step = "Step",
  VerbalGuidance = "VerbalGuidance",
  WrittenGuidance = "WrittenGuidance"
}
